module.exports = __webpack_public_path__ + "img/bonus-table-icon.c55313a4.svg";